import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { P00032 } from '../../../P00032';
import { P00030 } from '../../../P00030';
import {
  getPoolMasterClass,
  getPoolProduct,
} from '../../../../../ECoSystemsHelper';
import { IProduct } from '../../../../IProduct';
import { Pool } from '../../../../../../../apis/pool.api';

export function P0003600FiltrationMiseEnOeuvreInit(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  const master = getPoolMasterClass(pool);
  const product = getPoolProduct(pool, productClass);
  const produitP00032 = master?.hasProduct(pool, new P00032()) ?? 0;
  const produitP00030 = master?.hasProduct(pool, new P00030()) ?? 0;

  let force = false;

  const capteurTemperatureHorsGel = (val: number) => {
    if (produitP00032 == 0 && produitP00030 == 0) return 0;
    if (produitP00032 > 0 && produitP00030 == 0) return 1;
    if (produitP00032 == 0 && produitP00030 > 0) return 2;
    if (val == 0 && produitP00032 > 0 && produitP00030 > 0) return 1;

    return val;
  };

  editValue(
    P00039DataRxTxIndex.FiltrationStandard_Installation,
    'fsICapteurTemperatureFiltration2424',
    1,
    null,
    productClass,
  );

  editValue(
    P00039DataRxTxIndex.FiltrationStandard_Installation,
    'fsICapteurTemperatureReferenceLoiDEau',
    1,
    null,
    productClass,
  );

  const fsICapteurTemperatureReferenceHorsGel =
    product!.data.fsICapteurTemperatureReferenceHorsGel;
  const newFsICapteurTemperatureReferenceHorsGel = capteurTemperatureHorsGel(
    fsICapteurTemperatureReferenceHorsGel,
  );

  if (
    fsICapteurTemperatureReferenceHorsGel !=
    newFsICapteurTemperatureReferenceHorsGel
  ) {
    editValue(
      P00039DataRxTxIndex.FiltrationStandard_Installation,
      'fsICapteurTemperatureReferenceHorsGel',
      newFsICapteurTemperatureReferenceHorsGel,
      null,
      productClass,
    );
    force = true;

    if (newFsICapteurTemperatureReferenceHorsGel == 1) {
      editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage,
        'fsPSeuilTemperatureFonctionHorsGel',
        3,
        null,
        productClass,
      );
    } else if (newFsICapteurTemperatureReferenceHorsGel == 2) {
      editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage,
        'fsPSeuilTemperatureFonctionHorsGel',
        0,
        null,
        productClass,
      );
    }
  }

  editValue(
    P00039DataRxTxIndex.FiltrationStandard_Controle,
    'fsCResetManuelProtectionMagnetique',
    1,
    null,
    productClass,
  );
  editValue(
    P00039DataRxTxIndex.FiltrationStandard_Controle,
    'fsCResetManuelProtectionThermique',
    1,
    null,
    productClass,
  );

  return force;
}
